import { string, object, boolean } from "yup"

export const verifyOtpSchema = object({
  otp: string().min(6).max(6).label("Authentication Code").required(),
  rememberMe: boolean().label("Remember me").required(),
})

export const userLoginSchema = object({
  username: string().label("Username").required(),
  password: string().label("Password").required(),
})
